import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


const endpoint = environment.apiEmailFromUrl;

const httpOptions = {
headers: new HttpHeaders({
  'Content-Type':  'application/json'
})
};

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http: HttpClient) { }

  private extractData(res: Response) {
    const body = res;
    return body || { };
  }

  public cargaDatosPersonales(ctx): Observable<any> {
    //console.log("cargaDatosPersonales():: context: %s",JSON.stringify(ctx));
    return this.http.post<any>(endpoint + '/cargaDatosPersonales', JSON.stringify(ctx),
    httpOptions).pipe(map(this.extractData)
    );
  }

  public cargarContactosCEA(ctx): Observable<any> {
    //console.log("cargarContactosCEA():: context: %s",JSON.stringify(ctx));
    return this.http.post<any>(endpoint + '/cargarContactosCEA', JSON.stringify(ctx),
    httpOptions).pipe(map(this.extractData)
    );
  }

  public submitEmailForm(emailFormModel): Observable<any> {
    console.log("submitEmailForm():: emailFormModel: %s",JSON.stringify(emailFormModel));
    return this.http.post<any>(endpoint + '/submitEmailForm', JSON.stringify(emailFormModel),
    httpOptions).pipe(map(this.extractData)
    );
  }

  public submitEmailFormWithAttachments(emailFormModel): Observable<any> {
    const opt = {
      // Valores de header para que acepte datos y adjuntos
      headers: new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        //'Accept-Encoding':'multipart/form-data;charset=utf-8'
        'Accept-Encoding':'charset=utf-8'
        
      })
    };
    return this.http.post<any>(endpoint + '/submitEmailFormWithAttachments', emailFormModel, opt).pipe(map(this.extractData)
    );
  }



  public uploadFiles(formData): Observable<any> {
    console.log("uploadFiles():: formData: %s", JSON.stringify(formData));
    return this.http.post<any>(endpoint + '/uploadFiles', formData, httpOptions).pipe(map(this.extractData)
    );
  }
  

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`operation: ${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

 
}
